<template>
      <!-- <input type="file"
      :accept="accept" 
      :ref="id"
      @change="beforeUpload"
      class="input-file"
      > -->
  <el-upload class="upload-demo"
       :data="data"
      :accept="accept"
      :auto-upload="true"
      action="#"
      :ref="id"
      :http-request="httpRequest"
      :before-upload="beforeUpload"
      :show-file-list="false"
      :on-change="onChange"
      :disabled="disabled"
      :multiple="multiple"
     >
      <slot  slot="trigger"  name="upload"></slot>
  </el-upload>
</template>

<script>
export default {
  name: 'Upload',
  props:{
      drag:{
          type:[Boolean,String],
          default:false,
      },
      disabled:{
          type:[Boolean],
          default:false,
      },
      multiple:{
          type:[Boolean],
          default:false,
      },
      action:{//必传
          type:[String],
          default:'',
      },
      id:{//必传
          type:[String],
          default:'',
      },
      accept:{
          type:[String],
          default:'image/gif, image/jpeg, image/png',
      },
      booktype:{
         type:[String],
         default:'现代图书',
      },
      data:{
        defalt(){
          return {}
        }
      }
  },
  
  mounted() {
    //  if(this.multiple){
    //     this.$refs[this.id].multiple = 'multiple'
    //   }
  },
  methods:{
    onChange(file, fileList){
      this.fileList = fileList
      this.$emit('onChange',fileList)
    },
    beforeUpload(file){//这里很重要 上传之前的验证，如果 验证不通过就  return false  就不会走上传流程
      
      const isLt2M = file.size / 1024 / 1024 < 50
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 50MB!')
        return false
      }
      var files = file;
      console.log(files)
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        this.$emit('beforeUpload',file)
      }
    },
    httpRequest(obj,fileList){
      this.$emit('httpRequest',obj.file,this.fileList,this.booktype)
    },
    uploadSuccess(response, file, fileList){
      this.$emit('uploadSuccess',file)
    },
    uploadError(err, file, fileList){
      this.$emit('uploadError',file)
    },
  },
  data () {
    return {
      fileList:[]
    }
  }
}
</script>

<style scoped lang="scss">
.upload-demo{
  display: inline-block;
  text-align: center;
  // position: relative;
  // vertical-align: bottom;
  // cursor: pointer;
  // .input-file{
  //   cursor: pointer;
  //   width: 100%;
  //   position: absolute;
  //   opacity: 0;
  //   z-index: 1;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Upload/index.vue